class ProductOptionPanel {
    constructor(container) {
        this.container = container;
        this.customEvents = {};
        this._activePanel = null;
        this.init();
    }

    on(eventName, callback) {
        this.customEvents[eventName] = this.customEvents[eventName] || [];
        this.customEvents[eventName].push(callback);
    }

    emit(eventName, data) {
        data.type = eventName;
        if (this.customEvents[eventName]) {
            this.customEvents[eventName].forEach(function (callback) {
                callback(data, eventName);
            });
        }
    }

    set activePanel(panel) {
        if (this.activePanel) {
            // Get Previous Tab
            const previousTab = this.container.querySelector(`.productOptionPanelTab[data-tab="${this.activePanel.dataset.panel}"]`);

            // Remove old Active tab Class
            previousTab.classList.remove('active');

            // Hide Previous Panel
            this.activePanel.classList.remove('active');
        }

        // Set new active panel
        this._activePanel = panel;

        // Get Tab
        const tab = this.container.querySelector(`.productOptionPanelTab[data-tab="${panel.dataset.panel}"]`);

        // Set new active tab
        tab.classList.add('active');

        //Set new active panel
        panel.classList.add('active');
    }

    get activePanel() {
        return this._activePanel;
    }

    init() {
        // Set active panel
        this.activePanel = this.container.querySelector('.productOptionPanel.active');

        const tabs = this.container.querySelectorAll('.productOptionPanelTab');

        // Add event listeners to tabs
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                // get the tab's target
                const target = this.container.querySelector(`[data-panel="${tab.dataset.tab}"]`);

                // Update active panel
                this.activePanel = target;

                // Emit event
                this.emit('tabChange', {
                    tab: tab,
                    target: target
                });
            });
        });
    }
}